import React, {useState} from "react";
import {Link} from "react-router-dom";

const parallax = (setTranslateX, setTranslateX2, setTranslateX3, setTranslateY, setTranslateY2, setTranslateY3, e) => {
    setTranslateX(-e.clientX*10/800);
    setTranslateX2(-e.clientX*40/800);
    setTranslateX3(-e.clientX*80/800);

    setTranslateY(-e.clientY*10/800);
    setTranslateY2(-e.clientY*40/800);
    setTranslateY3(-e.clientY*80/800)
};

const MainPage = () => {
    let [translateX, setTranslateX] = useState(0);
    let [translateX2, setTranslateX2] = useState(0);
    let [translateX3, setTranslateX3] = useState(0);

    let [translateY, setTranslateY] = useState(0);
    let [translateY2, setTranslateY2] = useState(0);
    let [translateY3, setTranslateY3] = useState(0);
    return (
        <section className='home-page' onMouseMove={(e) => parallax(setTranslateX, setTranslateX2, setTranslateX3, setTranslateY, setTranslateY2, setTranslateY3,e)}>
            <div className="home-page__full-container">
                <div className="home-page__scene scene">
                    <div className="layer layer-bg" style={{transform: `translate(${translateX}px, ${translateY}px)`}}>

                    </div>
                    <div className="layer layer-up-bg " style={{transform: `translate(${translateX2}px, ${translateY2}px)`}}>

                    </div>
                    <div className="layer layer-up " style={{transform: `translate(${translateX3}px, ${translateY3}px)`}}>

                    </div>
                </div>
                <div className="home-page__container">
                    <div className="home-page__window home-page__header">
                        <div className="home-page__window-border">
                            <div className="home-page__small-window">
                                <h1>MY UNIVERSE</h1>
                                <div className="home-page__dignities">
                                    <div className="home-page__dignitie">
                                        <h3>ПРЕКРАСНЫЙ</h3>
                                        <h4>ДИЗАИН</h4>
                                    </div>
                                    <div className="home-page__dignitie">
                                        <h3>ПОЛНАЯ</h3>
                                        <h4>КОНФИДИЦИАЛЬНОСТЬ</h4>
                                    </div>
                                    <div className="home-page__dignitie">
                                        <h3>ЧЕТКОЕ</h3>
                                        <h4>ОБНОВЛЕНИЕ БД</h4>
                                    </div>
                                </div>
                                <div className='home-page__info-reg additional-text'><p>Если ты зашел сюда впервый раз, то нажимай кнопку регистрации и присоединяйся к нам. Будь в курсе всего нового.</p></div>
                                <div className="home-page__buttons">
                                    <div className="submit-button"><Link to={'/login'}><button>Регистрация</button></Link></div>
                                    <div className="submit-button"><Link to={'/login'}><button>Вход</button></Link></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
};

export default MainPage